export default __webpack_public_path__ + "3a06802a48146a4b55f97a3ce797e7e1.svg";